import {
  // eslint-disable-next-line no-restricted-imports
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from '@chakra-ui/react';
import { ContactForm } from '../ContactForm';

type ContactModalProps = {
  isOpen: boolean;
  onClose: () => void;
  defaultMessage?: string;
  defaultInterest?: string;
  title?: string;
  submitButtonText?: string;
};

export const ContactModal: React.FC<ContactModalProps> = ({
  isOpen,
  onClose,
  defaultMessage,
  defaultInterest,
  title = 'Contact Us',
  submitButtonText,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />
      <ModalContent borderRadius="16px" p={{ base: 4, sm: 6 }} mx={4}>
        <ModalHeader
          fontFamily="marketingPage"
          fontSize="xl"
          textAlign="center">
          {title}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <ContactForm
            onClose={onClose}
            defaultMessage={defaultMessage}
            title={title}
            submitButtonText={submitButtonText}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
